export const getParentPath = (planIndex: number, coverageIndex: number) =>
  `benefitPackagingDetail.plans[${planIndex}].coverageDefs[${coverageIndex}]`;

export const getHospitalCareServicesPropertyPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;
  return {
    isHosAdmissionApplied: `${parentPath}.isHosAdmissionApplied`,
    hosAdmissionDetails: `${parentPath}.hosAdmissionDetails`,
    benefitAmount: `${parentPath}.hosAdmissionDetails.benefitAmount.amount`,
    firstDayConfinementPaymentFreqLimitCd: `${parentPath}.hosAdmissionDetails.firstDayConfinementPaymentFreqLimitCd`,
  };
};

export const getHosAdmissionRoutineNewbornPropertyPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;
  return {
    isHospitalAdmissionRoutineNewbornApplied: `${parentPath}.isHospitalAdmissionRoutineNewbornApplied`,
    routineNewbornAmount: `${parentPath}.hosAdmissionRoutineNewbornDetails.routineNewbornAmount.amount`,
    maxLimit: `${parentPath}.hosAdmissionRoutineNewbornDetails.maxLimit`,
  };
};

export const getDailyHospitalConfinementPropertyPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;
  return {
    isHosConfinementApplied: `${parentPath}.isHosConfinementApplied`,
    hosConfinementDetails: `${parentPath}.hosConfinementDetails`,
    benefitAmount: `${parentPath}.hosConfinementDetails.benefitAmount.amount`,
    maxBenefitNumber: `${parentPath}.hosConfinementDetails.maxBenefitNumber`,
  };
};

export const getHosConfinementRoutineNewbornPropertyPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;
  return {
    isHospitalConfinementRoutineNewbornApplied: `${parentPath}.isHospitalConfinementRoutineNewbornApplied`,
    hosConfinementRoutineNewbornDetails: `${parentPath}.hosConfinementRoutineNewbornDetails`,
    routineNewbornAmount: `${parentPath}.hosConfinementRoutineNewbornDetails.routineNewbornAmount.amount`,
    confinementLimit: `${parentPath}.hosConfinementRoutineNewbornDetails.confinementLimit`,
  };
};

export const getIntensiveCareAdmissionPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;
  return {
    isICUConfinementApplied: `${parentPath}.isICUConfinementApplied`,
    icuConfinementDetails: `${parentPath}.icuConfinementDetails`,
    benefitAmount: `${parentPath}.icuConfinementDetails.benefitAmount.amount`,
    paymentFrequencyLimitCd: `${parentPath}.icuConfinementDetails.paymentFrequencyLimitCd`,
  };
};

export const getStepdownIntensiveCareAdmissionPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;

  return {
    isStepDownIntensiveCareAdmissionApplied: `${parentPath}.isStepDownIntensiveCareAdmissionApplied`,
    icuStepDownAdmissionDetails: `${parentPath}.icuStepDownAdmissionDetails`,
    benefitAmount: `${parentPath}.icuStepDownAdmissionDetails.benefitAmount.amount`,
    paymentFrequencyLimitCd: `${parentPath}.icuStepDownAdmissionDetails.paymentFrequencyLimitCd`,
  };
};

export const getObservationUnitPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;

  return {
    isObservationUnitApplied: `${parentPath}.isObservationUnitApplied`,
    observationUnitDetails: `${parentPath}.observationUnitDetails`,
    benefitAmount: `${parentPath}.observationUnitDetails.benefitAmount.amount`,
    mindurationCd: `${parentPath}.observationUnitDetails.mindurationCd`,
    separationPeriodCd: `${parentPath}.observationUnitDetails.separationPeriodCd`,
    benefitStructure: `${parentPath}.observationUnitDetails.benefitStructure`,
    maxdurationCd: `${parentPath}.observationUnitDetails.maxdurationCd`,
    paymentFrequencyLimitCd: `${parentPath}.observationUnitDetails.paymentFrequencyLimitCd`,
    isPrePostOperativeCareApplied: `${parentPath}.observationUnitDetails.isPrePostOperativeCareApplied`,
  };
};

export const getDailyIntensiveCareConfinementPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;

  return {
    icuDailyConfinementDetails: `${parentPath}.icuDailyConfinementDetails`,
    benefitAmount: `${parentPath}.icuDailyConfinementDetails.benefitAmount.amount`,
    maxBenefitNumber: `${parentPath}.icuDailyConfinementDetails.maxBenefitNumber`,
  };
};

export const getDailyStepdownIntensiveCareConfinementPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}.benefitStructure`;

  return {
    isDailyStepDownIntensiveCareConfinmentApplied: `${parentPath}.isDailyStepDownIntensiveCareConfinmentApplied`,
    icuDailyConfinementDetails: `${parentPath}.icuDailyStepDownConfinementDetails`,
    benefitAmount: `${parentPath}.icuDailyStepDownConfinementDetails.benefitAmount.amount`,
    maxBenefitNumber: `${parentPath}.icuDailyStepDownConfinementDetails.maxBenefitNumber`,
  };
};

export const getPortabilityPaths = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = `${getParentPath(planIndex, coverageIndex)}`;

  return {
    isPortabilityApplied: `${parentPath}.benefitStructure.isPortabilityApplied`,
    limitPortedCovDurationInd: `${parentPath}.benefitStructure.portabilityDetails.limitPortedCovDurationInd`,
    covDuration: `${parentPath}.benefitStructure.portabilityDetails.covDuration`,
  };
};
